interface Props {
  height: string;
  width: string;
  color: string;
  className?: string;
}

const ArrowPolygon: React.FC<Props> = (props) => {
  const { height, width, color, className } = props;

  return (
    <>
      {className ? (
        <svg
          width={width}
          height={height}
          viewBox="-50 -50 300 300"
          className={className}
        >
          <polygon
            style={{
              fill: color,
              stroke: color,
              strokeWidth: "50px",
            }}
            strokeLinejoin="round"
            points="100,0 0,200 200,200"
          />{" "}
        </svg>
      ) : (
        <svg width={width} height={height} viewBox="-50 -50 300 300">
          <polygon
            style={{
              fill: color,
              stroke: color,
              strokeWidth: "50px",
            }}
            strokeLinejoin="round"
            points="100,0 0,200 200,200"
          />
        </svg>
      )}
    </>
  );
};

export default ArrowPolygon;
